import { useEffect, useState } from "react";

export interface CountryEntry {
  name: string;
  alpha: string;
  dialingCodes: string[];
}

export type DialingCodeMap = { [dialingCode: string]: string };

export function useDialingCodes(): DialingCodeMap | null {
  const [dialingCodes, setDialingCodes] = useState<DialingCodeMap | null>(null);

  useEffect(() => {
    fetch("./countries.json")
      .then(res => res.json())
      .then((countries: CountryEntry[]) => {
        const map: DialingCodeMap = {};

        for (const country of countries) {
          for (const code of country.dialingCodes) {
            map[code] = country.alpha;
          }
        }

        setDialingCodes(map);
      });
  }, []);

  return dialingCodes;
}
